export const iconFontAwesomeEnergyPlugCirclePlus = (
	<i className="fa-solid fa-plug-circle-plus"></i>
);
